import {FileConfiguration} from '../../file/message/FileConfiguration';

export class ReadFile {
exitStatusOnReadFile: boolean | null;
file: FileConfiguration;
keepFile: boolean | null;
removeFile: boolean | null;
}

